<template>

  <v-card width="100%" class="pa-0 pb-4" tile>
    <v-row no-gutters>

      <v-col class="pa-0 pt-2">
        <v-text-field dense outlined class="rounded-0" label="штрихкод" hide-details
                      v-model="barcodeQuery"
                      @input="filterChange"
                      @keyup.enter="findByQueries"
        />
      </v-col>

      <v-col class="pa-0 pt-2">
        <v-text-field dense outlined class="rounded-0" label="род/вид/название на этикетке" hide-details
                      v-model="genusQuery"
                      @input="filterChange"
                      @keyup.enter="findByQueries"
        />
      </v-col>

      <v-col class="pa-0 pt-2">
        <v-text-field dense outlined class="rounded-0" label="республика/область сбора" hide-details
                      v-model="gatheringPlaceRegionQuery"
                      @input="filterChange"
                      @keyup.enter="findByQueries"
        />
      </v-col>

      <v-col class="pa-0 pt-2">
        <v-text-field dense outlined class="rounded-0" label="район сбора" hide-details
                      v-model="gatheringPlaceDistrictQuery"
                      @input="filterChange"
                      @keyup.enter="findByQueries"
        />
      </v-col>

      <v-col class="pa-0 pt-2 pr-3">
        <v-text-field dense outlined class="rounded-0" label="страна сбора" hide-details
                      v-model="gatheringPlaceCountryQuery"
                      @input="filterChange"
                      @keyup.enter="findByQueries"
        />
      </v-col>

      <v-btn x-small fab class="align-self-center mr-3 mt-1" color="#0d47a1" @click="findByQueries">
        <v-icon color="white">
          mdi-magnify
        </v-icon>
      </v-btn>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "SearchComponent",
  data () {
    return {
      genusQuery: '',
      barcodeQuery: '',
      gatheringPlaceRegionQuery: '',
      gatheringPlaceDistrictQuery: '',
      gatheringPlaceCountryQuery: '',
    }
  },
  methods: {
    filterChange(query) {
      this.$emit('filter', {
        'genus-or-species': this.genusQuery,
        barcode: this.barcodeQuery,
        gatheringPlaceRegion: this.gatheringPlaceRegionQuery,
        gatheringPlaceDistrict: this.gatheringPlaceDistrictQuery,
        gatheringPlaceCountry: this.gatheringPlaceCountryQuery,
      })
    },

    findByQueries() {
      this.$emit('find', {
        'genus-or-species': this.genusQuery,
        barcode: this.barcodeQuery,
        gatheringPlaceRegion: this.gatheringPlaceRegionQuery,
        gatheringPlaceDistrict: this.gatheringPlaceDistrictQuery,
        gatheringPlaceCountry: this.gatheringPlaceCountryQuery,
      })
    }
  },
}
</script>

<style scoped>

</style>